import { useUploadPjs } from '@mairistem/comptabilite';

import { FicheBar } from '@mairistem/fiche';
import React from 'react';

interface SubventionFicheBarConsumerProps {
	identifiant: number;
	onSaving: any;
	onError: any;
	onSaved: any;
}

export const handleCreatingFicheSubvention = (data) => ({
	...data,
	identifiantEntite: parseInt(sessionStorage.getItem('identifiantEntite'), 10),
	realisationHT: 1,
	tauxAide: data?.tauxAide ?? 0,
});

const SubventionFicheBarConsumer = (props: SubventionFicheBarConsumerProps) => {
	const { identifiant, onSaving, onSaved, ...handlers } = props;

	const uploadPjs = useUploadPjs();

	const handleSaved = (data, status) => {
		onSaved(data, status);
		uploadPjs(data?.identifiant);
	};

	return (
		<FicheBar
			{...handlers}
			type="subvention"
			identifiant={identifiant}
			canDraft={false}
			onSaving={onSaving}
			onSaved={handleSaved}
			onCreating={handleCreatingFicheSubvention}
		/>
	);
};

export default SubventionFicheBarConsumer;
